export const black = '#2C2408';
export const white = '#FCFCFC';
export const whiteSmoke = '#F9F9F9';
export const blue = '#0A4A8D';
export const navyBlue = '#1D3146';
export const green = '#03906A';
export const red = '#CC3736';
export const lightGrayBlue = '#E4EDF4';
export const pureBlack = '#000';
export const darkGrey = '#0e1823';
export const lightBlue = '#F0F2F8';
export const yukonGold = '#AE9337';
export const loadingGrey = '#D9DCE0';
export const shuttleGrey = '#58687A';
export const paleBlue = '#DEEEFF';
export const blackBlue = '#0D2A43';
export const pattensBlue = '#DBE5F0';
export const cobaltStoneBlue = '#0363ad';
export const limeGreen = '#2dae2c';
export const darkGreen = '#03906A';
export const pureWhite = '#FFFFFF';
export const cyanDarkBlue = '#222a34';
export const darkCyanBlue = '#052546';
export const darkGreenShade = '#026046';
export const cyanBlueLight = '#1891ff';
export const steelBlue = '#6589C3';
export const lightGrey = '#D1D3D4';
export const lightBlue1 = '#9DDCF9';
